import { render, staticRenderFns } from "./InvestJoin.vue?vue&type=template&id=d04d1030&scoped=true&"
import script from "./InvestJoin.vue?vue&type=script&lang=js&"
export * from "./InvestJoin.vue?vue&type=script&lang=js&"
import style0 from "./InvestJoin.vue?vue&type=style&index=0&id=d04d1030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04d1030",
  null
  
)

export default component.exports